<template>
  <div class="store__bottle-free-coolers">
    <div class="products">
      <div class="product" v-for="product in products">
        <div>
          <span class="product__name" v-html="product.name"></span>

          <div class="product__img">
            <img v-bind:src="product.image" v-bind:alt="product.name">
          </div>

          <div class="product__description rich-text" v-html="product.description"></div>
        </div>
        <div>
          <span class="product__price">${{ product.price }}/mo.*</span>
          <button type="button" class="btn btn-store" v-on:click="addToCart(product)">Add to Order</button>
        </div>
      </div> <!-- .product -->

      <div class="product product--placeholder product--disclaimer">
        <div class="text-start" v-html="disclaimer"></div>
      </div>

      <div class="product product--placeholder"></div>
    </div> <!-- .products -->
  </div> <!-- .store__bottle-free-coolers -->
</template>

<script>
import store from '../../store.js'

export default {
  computed: {
    products() {
      return store.getters.getBottleFreeCoolers
    },
    disclaimer() {
      return ''
    }
  },
  methods: {
    addToCart(product) {
      store.dispatch('addToCart', {
        productId: product.id,
        options: {
          quantity: 1
        }
      })

      swal('', 'BFC successfully added to your cart.')

      // Go to Products
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      store.dispatch('goToProducts')
    }
  }
}
</script>
